import React from 'react';

const variantColors = {
  default: {
    backgroundColor: 'var(--color-bg-elevated)',
    color: 'var(--color-text-secondary)',
  },
  success: {
    backgroundColor: 'rgba(46, 204, 113, 0.15)',
    color: 'var(--color-success)',
  },
  warning: {
    backgroundColor: 'rgba(243, 156, 18, 0.15)',
    color: 'var(--color-warning)',
  },
  danger: {
    backgroundColor: 'rgba(231, 76, 60, 0.15)',
    color: 'var(--color-danger)',
  },
  info: {
    backgroundColor: 'rgba(52, 152, 219, 0.15)',
    color: 'var(--color-info)',
  },
  gold: {
    backgroundColor: 'rgba(212, 175, 55, 0.15)',
    color: 'var(--color-primary)',
  },
};

export default function Badge({ children, variant = 'default', style }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 10px',
        borderRadius: 'var(--radius-full)',
        fontSize: '0.75rem',
        fontWeight: 600,
        fontFamily: 'var(--font-display)',
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        ...variantColors[variant],
        ...style,
      }}
    >
      {children}
    </span>
  );
}
